import BaseMessage from '@/global/BaseMessage.vue'

const message = {
  messageData: {
    isDisplay: false,
    text: '',
    color: 'error',
    time: 3000
  },
  close() {
    Object.assign(this.messageData, { isDisplay: false, text: '' })
  },
  show(color, text, time) {
    Object.assign(this.messageData, { isDisplay: true, text, color, time })
  },
  error(msg) {
    const getErrorMessage = (error) => {
      if (!error.response || !error.response.data) return error
      if (!error.response.data.stackTrace) return error.response.data.errorMessage || 'Internal Server Error'
      const message = JSON.parse(JSON.stringify(error.response.data.stackTrace))
      const splitError = message.split(`\n`)
      return splitError[0] || 'Internal Server Error'
    }
    const message = typeof msg === 'object' ? getErrorMessage(msg) : msg
    this.show('error', message, 10000)
  },
  success(msg) {
    this.show('success', msg)
  },
  warning(msg) {
    this.show('warning', msg)
  },
  info(msg) {
    this.show('dark', msg)
  },
  loading(msg, time) {
    this.show('grey darken-2', msg, time)
  }
}

export default {
  install(Vue, pluginName = '$message') {
    Vue.prototype[pluginName] = message
    Vue.component('plugin-message', BaseMessage)
  }
}

export { message }
